<template>
	<div class="bg">
		<div class="flexs" style="padding-top: 20px; padding-left: 20px;">
			<div v-for="(tab, i) in tabs" :key="i"
				style="height: 32px; width: 88px; margin-right: 12px; cursor: pointer;"
				:class="['flexc', activeTab === i ? 'select' : '']" @click="handleTabChange(i)">
				{{ tab.label }}
			</div>
		</div>
		<div class="search-container">
			<div style="font-size: 16px; font-weight: bold; padding-bottom: 16px;">查询订单</div>

			<!-- 搜索表单区域 -->
			<div class="search-form">
				<!-- 收货人 -->
				<div class="input-wrapper">
					<label class="input-label">收货人：</label>
					<el-input v-model="searchParams.userName" placeholder="请输入收货人姓名" clearable
						style="background-color: #F2F3F5;" @keyup.enter="handleSearch" />
				</div>
				<!-- 手机号 -->
				<div class="input-wrapper">
					<label class="input-label">手机号：</label>
					<el-input v-model="searchParams.customerPhone" placeholder="请输入手机号" clearable
						style="background-color: #F2F3F5;" @keyup.enter="handleSearch" />
				</div>
			<!-- 订单号 -->
			<div class="input-wrapper">
				<label class="input-label">订单号：</label>
				<el-input v-model="searchParams.orderSeq" placeholder="请输入订单号" clearable
					style="background-color: #F2F3F5;" @keyup.enter="handleSearch" />
			</div>
			<!-- 开始时间 -->
			<div class="input-wrapper">
				<label class="input-label">开始时间：</label>
				<el-date-picker v-model="searchParams.orderStartTimeBegin" type="datetime" value-format="yyyy-MM-dd hh:mm:ss"
					placeholder="请选择开始时间" clearable style="width: 100%; background-color: #F2F3F5;">
				</el-date-picker>
			</div>
			<!-- 结束时间 -->
			<div class="input-wrapper">
				<label class="input-label">结束时间：</label>
				<el-date-picker v-model="searchParams.orderStartTimeEnd" type="datetime" value-format="yyyy-MM-dd hh:mm:ss"
					placeholder="请选择结束时间" clearable style="width: 100%; background-color: #F2F3F5;">
				</el-date-picker>
			</div>
			<div class="divider"></div>
				<!-- 搜索按钮 -->
				<div class="search flexc" style="cursor: pointer;" @click="handleSearch">
					<img src="/images/goodsList/search.svg" width="14px" height="14px" alt="" />
					<div class="" style="margin-left: 4px; font-size: 14px;">查询</div>
				</div>
				<!-- 重置按钮 -->
				<div class="reset flexc" style="cursor: pointer;" @click="handleReset">
					<div class="" style="margin-left: 4px; font-size: 14px;">重置</div>
				</div>

			</div>
		</div>
		<div style="margin-top: 20px;">
			<el-table ref="etb2" class="custom-header-table" :height="tblHeight" v-loading="tableLoading"
				:data="filteredOrderList">
				<el-table-column type="index" label="序号" width="70" align="center" :index="getTableIndex"></el-table-column>
				<el-table-column label="订单号" width="200" align="center">
					<template slot-scope="scope">
						<div class="">{{ scope.row.orderSeq}}</div>
					</template>
				</el-table-column>
				<el-table-column label="下单人" align="center">
					<template slot-scope="scope">
						<div class="price">{{ scope.row.userName}}</div>
					</template>
				</el-table-column>
				<el-table-column label="收货人" align="center">
					<template slot-scope="scope">
						<div class="price">{{ scope.row.userName}}</div>
					</template>
				</el-table-column>
				<el-table-column label="联系方式" align="center">
					<template slot-scope="scope">
						<div class="price">{{ scope.row.customerPhone}}</div>
					</template>
				</el-table-column>
				<el-table-column label="商品名称" min-width="200" align="center" show-overflow-tooltip>
					<template slot-scope="scope">
						<div class="ellipsis">{{ scope.row.goodsName || '--' }}</div>
					</template>
				</el-table-column>
				<el-table-column label="商品数量" align="center">
					<template slot-scope="scope">
						<div class="price">{{ scope.row.num}}</div>
					</template>
				</el-table-column>
				<el-table-column label="商品金额" align="center">
					<template slot-scope="scope">
						<div class="price">{{ getGoodsAmount(scope.row) }}</div>
					</template>
				</el-table-column>
				<el-table-column label="下单时间" align="center">
					<template slot-scope="scope">
						<div class="price">{{ scope.row.startTime}}</div>
					</template>
				</el-table-column>
				<el-table-column label="订单状态" align="center">
					<template slot-scope="scope">
						<span :class="['status-tag', getOrderStatus(scope.row.orderState).className]">
							{{ getOrderStatus(scope.row.orderState).label }}
						</span>
					</template>
				</el-table-column>
				<el-table-column label="操作" align="center" fixed="right" width="140">
					<template slot-scope="scope">
				<div v-if="getOrderStatus(scope.row.orderState).value === '1'">
						<div class="action action-primary" :class="{ 'action-loading': isReadyLoading(scope.row) }"
							@click="handleReady(scope.row)">
							<i v-if="isReadyLoading(scope.row)" class="el-icon-loading" style="margin-right: 4px;"></i>
							{{ isReadyLoading(scope.row) ? '处理中' : '已备货' }}
						</div>
					</div>
				<div v-else-if="getOrderStatus(scope.row.orderState).value === '2'">
						<div class="action action-primary" :class="{ 'action-loading': isReadyLoading(scope.row) }"
							@click="handleReceived(scope.row)">
							<i v-if="isReadyLoading(scope.row)" class="el-icon-loading" style="margin-right: 4px;"></i>
							{{ isReadyLoading(scope.row) ? '处理中' : '已收货' }}
						</div>
					</div>
				<div v-else-if="getOrderStatus(scope.row.orderState).value === '20'">
						<div class="action" :class="[isUserBlocked(scope.row) ? 'action-default' : 'action-danger', { 'action-loading': isBlockLoading(scope.row) }]"
							@click="handleBlockToggle(scope.row)">
							<i v-if="isBlockLoading(scope.row)" class="el-icon-loading" style="margin-right: 4px;"></i>
							{{ isUserBlocked(scope.row) ? '取消拉黑' : '拉黑用户' }}
							</div>
						</div>
						<div v-else class="action-text">无</div>
					</template>
				</el-table-column>
			</el-table>
			<div class="flexb" style="margin-top: 20px;">
				<div class="down flexc" style="margin-left: 20px; cursor: pointer;" @click="handleExport">
					<i class="el-icon-folder-add" style="padding-right: 4px;"></i>
					导出
				</div>
				<div class="flexe" style="margin-top: 12px;">
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="pagination.currentPage" :page-sizes="[10, 20, 30, 40]"
						:page-size="pagination.pageSize" layout="total, sizes, prev, pager, next, jumper"
						:total="pagination.total" background>
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		storeApi
	} from "@/api";
	export default {
		data() {
			return {
				tableLoading: false,
				searchBtnLoading: false,
			activeTab: 0, // 当前激活的 tab
			tabs: [{
					label: '全部',
					value: 'all'
				},
				{
					label: '已订购',
					value: '1'
				},
				{
					label: '已接单（已备货）',
					value: '2'
				},
				{
					label: '待评价（已拿货）',
					value: '3'
				},
				{
					label: '已评价（已拿货）',
					value: '4'
				},
				{
					label: '已取消',
					value: '20'
				},
				{
					label: '异常',
					value: '21'
				}
			],
				// 搜索参数
			searchParams: {
				userName: '', // 收货人姓名
				customerPhone: '', // 手机号
				orderSeq: '', // 订单号
				orderStartTimeBegin: '', // 开始时间
				orderStartTimeEnd: '', // 结束时间
				status: 'all' // 订单状态筛选
			},
				// 分页参数
			pagination: {
				currentPage: 1,
				pageSize: 10,
				total: 0
			},
		readyLoadingId: null,
		blockLoadingId: null,
		orderList: [],
	}
},
	computed: {
		filteredOrderList() {
			if (this.searchParams.status === 'all') {
				return this.orderList;
			}
			return this.orderList.filter((item) => {
				return this.getOrderStatus(item.orderState).value === this.searchParams.status;
			});
		}
	},
	created() {
		this.getOrderList();
	},
		methods: {
			// Tab切换
			handleTabChange(index) {
				this.activeTab = index;
				this.searchParams.status = this.tabs[index].value;
				this.pagination.currentPage = 1; // 切换tab时回到第一页
				this.getOrderList();
			},

			// 搜索
			handleSearch() {
				this.pagination.currentPage = 1; // 搜索时回到第一页
				this.getOrderList();
			},

			// 重置搜索条件
			handleReset() {
			this.searchParams = {
				userName: '',
				customerPhone: '',
				orderSeq: '',
				orderStartTimeBegin: '',
				orderStartTimeEnd: '',
				status: 'all'
			};
				this.activeTab = 0;
				this.pagination.currentPage = 1;
				this.getOrderList();
			},

			// 每页条数改变
			handleSizeChange(pageSize) {
				this.pagination.pageSize = pageSize;
				this.pagination.currentPage = 1; // 条数改变时回到第一页
				this.getOrderList();
			},

		// 当前页改变
		handleCurrentChange(currentPage) {
			this.pagination.currentPage = currentPage;
			this.getOrderList();
		},

	isReadyLoading(row) {
		const orderId = row.orderId || row.id;
		if (!orderId) {
			return false;
		}
		return this.readyLoadingId === orderId;
	},

	normalizeOrderTime(value) {
		if (!value) {
			return '';
		}
		const datePart = String(value).split(' ')[0];
		return `${datePart} 00:00:00`;
	},

	isBlockLoading(row) {
		const memberUserId = row.creator;
		if (!memberUserId) {
			return false;
		}
		return this.blockLoadingId === memberUserId;
	},

	isUserBlocked(row) {
		if (!row) {
			return false;
		}
		return Number(row.isUserBlocked) === 1;
	},

	// 序号
	getTableIndex(index) {
		return (this.pagination.currentPage - 1) * this.pagination.pageSize + index + 1;
	},

		// 订单状态显示
		getOrderStatus(orderState) {
			const state = Number(orderState);
			const statusMap = {
				1: {
					label: '已订购',
					value: '1',
					className: 'status-pending'
				},
				2: {
					label: '已接单（已备货）',
					value: '2',
					className: 'status-success'
				},
				3: {
					label: '待评价（已拿货）',
					value: '3',
					className: 'status-pending'
				},
				4: {
					label: '已评价（已拿货）',
					value: '4',
					className: 'status-success'
				},
				20: {
					label: '已取消',
					value: '20',
					className: 'status-cancelled'
				},
				21: {
					label: '异常',
					value: '21',
					className: 'status-exception'
				}
			};
			return statusMap[state] || {
				label: '未知状态',
				value: 'unknown',
				className: 'status-exception'
			};
		},

		// 商品金额
		getGoodsAmount(row) {
			const amount = row.totalPrice != null ? row.totalPrice : (row.orderTotalAmount != null ?
				row.orderTotalAmount : row.receivedAmount);
			return this.formatAmount(amount);
		},

		formatAmount(value) {
			if (value === 0) {
				return 0;
			}
			return value || '--';
		},

		// 获取订单列表
		async getOrderList() {
			this.tableLoading = true;
			try {
					// 构建请求参数
					const params = {
						pageNo: this.pagination.currentPage,
						pageSize: this.pagination.pageSize,
						isDelivery: 1 // 外卖订单
					};

					// 添加搜索条件（如果有值）
					if (this.searchParams.userName) {
						params.userNameLike = this.searchParams.userName.trim();
					}
					if (this.searchParams.customerPhone) {
						params.customerPhone = this.searchParams.customerPhone.trim();
					}
				if (this.searchParams.orderSeq) {
					params.orderSeqLike = this.searchParams.orderSeq.trim();
				}
				if (this.searchParams.orderStartTimeBegin) {
					params.orderStartTimeBegin = this.normalizeOrderTime(this.searchParams.orderStartTimeBegin);
				}
				if (this.searchParams.orderStartTimeEnd) {
					params.orderStartTimeEnd = this.normalizeOrderTime(this.searchParams.orderStartTimeEnd);
				}
				// 添加状态条件（如果不是全部）
				// 订单状态筛选暂时在前端处理

					const response = await storeApi.order(params);

					if ((response.code === 0 || response.code === 200) && response.data) {
						this.orderList = response.data.list || [];
						this.pagination.total = response.data.total || response.data.count || 0;

						// 如果没有数据且不是第一页，则自动跳转到上一页
						if (this.orderList.length === 0 && this.pagination.currentPage > 1) {
							this.pagination.currentPage -= 1;
							this.getOrderList(); // 重新获取上一页数据
							return;
						}
					} else {
						this.$message.error(response.msg || '获取订单列表失败');
					}
				} catch (err) {
					console.error('获取订单列表错误:', err);
					this.$message.error('网络异常，无法获取订单列表');
				} finally {
					this.tableLoading = false;
					this.searchBtnLoading = false;
				}
			},

		// 导出功能
		async handleExport() {
			const exportParams = {
				pageNo: 1,
				pageSize: this.pagination.total || this.pagination.pageSize,
				orderId: null,
				isDelivery: 1,
				orderState: this.getExportOrderState(),
				customerNameLike: this.searchParams.userName ? this.searchParams.userName.trim() : '',
				customerPhone: this.searchParams.customerPhone ? this.searchParams.customerPhone.trim() : '',
				orderSeq: this.searchParams.orderSeq ? this.searchParams.orderSeq.trim() : '',
				orderStartTimeBegin: this.normalizeOrderTime(this.searchParams.orderStartTimeBegin),
				orderStartTimeEnd: this.normalizeOrderTime(this.searchParams.orderStartTimeEnd)
			};
			try {
				const response = await storeApi.exportOrder(exportParams);
				const blob = response.data;
				if (blob && blob.type && blob.type.includes('application/json')) {
					const text = await blob.text();
					const data = JSON.parse(text);
					this.$message.error(data.msg || '导出失败');
					return;
				}
				const fileName = this.getExportFileName(response, '外卖订单.xlsx');
				const url = window.URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.href = url;
				link.download = fileName;
				link.click();
				window.URL.revokeObjectURL(url);
			} catch (err) {
				console.error('导出订单失败:', err);
				this.$message.error('导出失败，请重试');
			}
		},

		getExportOrderState() {
			if (this.searchParams.status === 'all') {
				return null;
			}
			const state = Number(this.searchParams.status);
			return Number.isNaN(state) ? null : state;
		},

		getExportFileName(response, defaultName) {
			const disposition = response && response.headers ? response.headers['content-disposition'] : '';
			if (!disposition) {
				return defaultName;
			}
			const match = disposition.match(/filename\*=UTF-8''([^;]+)|filename=([^;]+)/i);
			const fileName = decodeURIComponent((match && (match[1] || match[2])) || '').replace(/"/g, '');
			return fileName || defaultName;
		},

		// 已备货
		async handleReady(row) {
			const orderId = row.orderId || row.id;
			if (!orderId) {
				this.$message.warning('订单ID缺失，无法操作');
				return;
			}
			if (this.readyLoadingId === orderId) {
				return;
			}
			this.readyLoadingId = orderId;
			this.tableLoading = true;
			try {
				const response = await storeApi.goodsReady(orderId);
				if (response.code === 0 || response.code === 200) {
					this.$message.success('已备货');
					this.getOrderList();
				} else {
					this.$message.error(response.msg || '已备货失败');
				}
			} catch (err) {
				console.error('已备货错误:', err);
				this.$message.error('网络异常，操作失败');
			} finally {
				this.tableLoading = false;
				this.readyLoadingId = null;
			}
		},

		// 已收货
		async handleReceived(row) {
			const orderId = row.orderId || row.id;
			if (!orderId) {
				this.$message.warning('订单ID缺失，无法操作');
				return;
			}
			if (this.readyLoadingId === orderId) {
				return;
			}
			this.readyLoadingId = orderId;
			this.tableLoading = true;
			try {
				const response = await storeApi.goodsReceived(orderId);
				if (response.code === 0 || response.code === 200) {
					this.$message.success('已收货');
					this.getOrderList();
				} else {
					this.$message.error(response.msg || '已收货失败');
				}
			} catch (err) {
				console.error('已收货错误:', err);
				this.$message.error('网络异常，操作失败');
			} finally {
				this.tableLoading = false;
				this.readyLoadingId = null;
			}
		},

		// 拉黑/取消拉黑
		async handleBlockToggle(row) {
			const memberUserId = row.creator || row.memberUserId;
			if (!memberUserId) {
				this.$message.warning('用户ID缺失，无法操作');
				return;
			}
			if (this.blockLoadingId === memberUserId) {
				return;
			}
			const wasBlocked = this.isUserBlocked(row);
			this.blockLoadingId = memberUserId;
			try {
				const response = await storeApi.blockOrCancelBlock(memberUserId);
				if (response.code === 0 || response.code === 200) {
					this.$message.success(wasBlocked ? '已取消拉黑' : '已拉黑用户');
					await this.getOrderList();
				} else {
					this.$message.error(response.msg || '操作失败');
				}
			} catch (err) {
				console.error('拉黑/取消拉黑错误:', err);
				this.$message.error('网络异常，操作失败');
			} finally {
				this.blockLoadingId = null;
			}
		}
	}
}
</script>

<style scoped>
	.status-tag {
		display: inline-block;
		padding: 2px 8px;
		border-radius: 12px;
		font-size: 12px;
		line-height: 18px;
	}

	.status-pending {
		color: #FA8C16;
		background: rgba(250, 140, 22, 0.12);
	}

	.status-success {
		color: #00B42A;
		background: rgba(0, 180, 42, 0.12);
	}

.status-cancelled {
	color: #F53F3F;
	background: rgba(245, 63, 63, 0.12);
}

.status-exception {
	color: #722ED1;
	background: rgba(114, 46, 209, 0.12);
}

	.action {
		cursor: pointer;
	}

	.action-primary {
		color: #00B42A;
	}

	.action-loading {
		opacity: 0.6;
		pointer-events: none;
	}

	.action-danger {
		color: #F53F3F;
	}

	.action-default,
	.action-text {
		color: #86909C;
	}
</style>
